<script setup>
  import { computed } from 'vue';
  import { intervalToDuration, isAfter } from 'date-fns'
  import Icon from './icons/Icon.vue';
  import { useI18n } from 'vue-i18n';
  import { useTideEventName } from '@/composables/useTideEventName';

  const { t } = useI18n();
  const { translateTideEventName } = useTideEventName();

  const props = defineProps({
    nextTideEvent: {
      type: Object,
      default: null
    },
    nowTideValues: {
      type: Array,
      required: true
    },
    units: {
      type: String,
      required: true
    }
  });

  const nextEventTimeFromNow = computed(() => {
    const now = Date.now();
    const target =  props.nextTideEvent?.dateTime ? new Date(props.nextTideEvent.dateTime) : null;

    if (!isAfter(target, now)) return t('containers.tides.now');

    const { hours, minutes } = intervalToDuration({ start: now, end: target });

    let parts = [];
    if (hours) parts.push(t('containers.tides.hoursAbbrev', hours));
    if (minutes) parts.push(t('containers.tides.minutesAbbrev', minutes));

    return t('containers.tides.inDuration', { duration: parts.join(` ${t('containers.tides.and')} `) });
  })  
</script>

<template>
  <div class="jwx-tide-spot__event-group" data-content="now-data">
    <div class="jwx-tide-spot__now-container">
      <div class="jwx-tide-spot__now-data">
        <p class="jwx-tide-spot__now-value">{{ props.nowTideValues[1] }} <span class="jwx-tide-spot__now-value-units">{{ props.units }}</span></p>
        <Icon :name="props.nowTideValues[2] === 'rising' ? 'arrow-thin-up-right' : 'arrow-thin-down-right'" class="jwx-tide-spot__now-icon" />
      </div>
      <div v-if="props.nextTideEvent" class="jwx-tide-spot__next-event">
        <p class="jwx-tide-spot__next-event-label">{{ t('containers.tides.next') }}</p>
        <p class="jwx-tide-spot__next-event-name">{{ translateTideEventName(props.nextTideEvent?.eventName) }}</p>
        <p class="jwx-tide-spot__next-event-time">{{ nextEventTimeFromNow }}</p>
      </div>
    </div>
  </div>
</template>